import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { assert } from '@ember/debug';
import V2TaskModel from 'donor-elf-web/models/v2-task';
import logger from 'donor-elf-web/lib/logger';
import TaskService from 'donor-elf-web/services/task-service';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import type {
  onTaskSaveErrorCallback,
  onTaskSavedCallback,
  onTaskSavingCallback,
} from '.';

interface ComponentArgs {
  task: V2TaskModel;
  onTaskSaving?: onTaskSavingCallback;
  onTaskSaved: onTaskSavedCallback;
  onTaskSaveError?: onTaskSaveErrorCallback;
}

export default class TaskInfoMarkCompleteBoxComponent extends Component<ComponentArgs> {
  constructor(owner: any, args: ComponentArgs) {
    super(owner, args);
    assert(
      '@onTaskSaved() argument must be present for Task::Info::NewMarkComplete',
      typeof args.onTaskSaved === 'function',
    );
  }

  @service declare taskService: TaskService;
  @tracked saving = false;

  _taskAction?: string;
  get taskAction() {
    if (this._taskAction) {
      return this._taskAction;
    }
    return (this._taskAction =
      this.taskService.actionsById[this.args.task.actionId!]);
  }

  get availableResults() {
    return sortByProperties(
      this.taskService.availableResultsByActionId[this.taskAction?.id],
      ['label:asc'],
    );
  }

  @action
  async saveResult(result: any) {
    try {
      this.args.onTaskSaving?.({ saving: true, task: this.args.task });
      this.saving = true;
      this.args.task.resultId = result.id;
      this.args.task.completedDate = new Date();
      await this.args.task.save();
      this.args.onTaskSaving?.({ saving: false, task: this.args.task });
      this.args.onTaskSaved(this.args.task);
    } catch (error) {
      if (!this.args.task.isNew) {
        this.args.task.rollbackAttributes();
      }
      this.args.onTaskSaving?.({ saving: false, task: this.args.task });
      this.args.onTaskSaveError?.({ task: this.args.task, error: error });
      logger.error(error);
    }
  }
}
